import { replaceCurriculum } from 'src/store/curriculum';
import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.Class>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'classes',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    replaceEntities(state, action: PayloadAction<Model.Class[]>) {
      adapter.setAll(state, action);
    },
    updateEntities(state, action: PayloadAction<Model.Class[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Class>) {
      adapter.upsertOne(state, action);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(replaceCurriculum, (state, action) => {
      const { course, sections, lessons } = action.payload.snapshot;
      adapter.upsertOne(state, {
        ...course,
        week_topics: sections.map((section) => ({
          ...section,
          class_topics: lessons.filter(
            (lesson) => lesson.week_topic_id === section.id,
          ),
        })),
      });
    });
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.classes,
);

export const classesSelector = createSelector(
  (state: RootState) => state.model.classes,
  (state: RootState) => state.model.class_user,
  (state: RootState) => state.ui.app.me,
  (classes, class_user, user) => {
    const isStudent = user?.roles?.every((role) => role.name === 'Student');

    const userCourses = Object.values(class_user.entities).filter(
      (class_user) => {
        if (isStudent) {
          return !!class_user?.is_paid;
        }

        return true;
      },
    );

    const allClasses = Object.values(classes.entities).map((cls) => {
      const is_active = userCourses.map((c) => c?.class_id).includes(cls?.id);

      return { ...cls, is_active };
    }) as Model.Class[];

    // allClasses.sort((a: Model.Class, b: Model.Class) => {
    //   if (a.is_active && !b.is_active) {
    //     return -1;
    //   }
    //   if (!a.is_active && b.is_active) {
    //     return 1;
    //   }
    //   if (a.start_date > b.start_date) {
    //     return -1;
    //   }
    //   if (a.start_date < b.start_date) {
    //     return 1;
    //   }
    //   return 0;
    // });
    // const classesWithPublic = allClasses.filter(
    //   (course) => !!course.is_published,
    // );

    return {
      data: allClasses,
      loading: classes.loading,
    };
  },
);

export const classByIdSelector = selector.selectById;

export { reducer };
export default actions;
